import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appDarkenColor',
  standalone: true,
})
export class DarkenColorPipe implements PipeTransform {
  transform(hexColor: string, luminosity: number = 0.03): string {
    return this.darkenColor(hexColor, luminosity);
  }

  /**
   * Reduces the brightness of a HEX color
   */
  private darkenColor(hex: string, factor: number): string {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    r = Math.max(0, Math.floor(r * (1 - factor)));
    g = Math.max(0, Math.floor(g * (1 - factor)));
    b = Math.max(0, Math.floor(b * (1 - factor)));

    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  }
}
